import { render } from "./SelectTheme.vue?vue&type=template&id=230e0ac7&scoped=true"
import script from "./SelectTheme.vue?vue&type=script&lang=js"
export * from "./SelectTheme.vue?vue&type=script&lang=js"

import "./SelectTheme.vue?vue&type=style&index=0&id=230e0ac7&scoped=true&language=scss&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-230e0ac7"]])

export default __exports__